/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import {
    object, shape, string, func,
} from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { trackEvent as trackEventActions } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';

const styles = (theme) => ({
    bannerText: {
        '& *': {
            marginTop: 0,
            marginBottm: '25px',
            fontSize: '28px',
            fontFamily: 'PlayfairDisplay, serif',
            fontWeight: 'normal',
            textAlign: 'center',
            [theme.breakpoints.down(600)]: {
                lineHeight: '34px',
            },
        },
    },
    bannerSubText: {
        fontSize: 14,
        display: 'flex',
        flexWrap: 'wrap',
        '& p': {
            padding: '0 5px',
            margin: '0 0 20px 0',
            flex: '0 0 50%',
            textAlign: 'center',
            '& strong': {
                display: 'block',
                letterSpacing: '1.47px',
            },
            [theme.breakpoints.down(600)]: {
                flex: '0 0 100%',
            },
        },
        '& p:last-child': {
            flex: '0 0 100%',
        },
    },
    ctaBtnContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    ctaBtn: {
        display: 'inline-block',
        color: '#FFF',
        backgroundColor: '#0A512E',
        textDecoration: 'none',
        lineHeight: '43px',
        fontSize: '14px',
        textAlign: 'center',
        margin: '0 auto',
        letterSpacing: '1.47px',
        fontWeight: 'bold',
        padding: '0 30px',
        position: 'relative',
        [theme.breakpoints.down(600)]: {
            backgroundColor: 'transparent',
            color: '#000',
            lineHeight: '18px',
        },
    },
    tilesterms: {
        marginTop: '10px',
        fontSize: '14px',
        textAlign: 'center',
        color: '#000000',
        '& button': {
            cursor: 'pointer',
            textDecoration: 'underline',
            color: '#000000',
            background: 'transparent',
            border: 'none',
            padding: 0,
            margin: 0,
        },
    },
    contextBoxPosition: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '90px',
        marginRight: '90px',
        height: 'inherit',
        [theme.breakpoints.down(769)]: {
            marginLeft: '20px',
            marginRight: '20px',
            justifyContent: 'center !important',
        },
        [theme.breakpoints.down(600)]: {
            marginLeft: '20px',
            marginRight: '20px',
            alignItems: 'flex-start',
        },
    },
    contentBoxContainer: {
        display: 'inline-block',
        width: '650px',
        padding: '20px',
        background: 'rgba(255,255,255,0.9)',
        [theme.breakpoints.down(600)]: {
            marginTop: '20px',
            marginBottom: '100px',
        },
    },
    contentInnerBoxContainer: {
        border: '1px solid #000',
        padding: '30px 20px',
    },
});
const SubscriptionBlock = ({
    classes, item, scrollToDisclaimer, trackEvent,
}) => {
    if (!item) {
        return null;
    }
    const subscriptionBlockData = item?.subscription_block;
    const url = subscriptionBlockData?.desktop_image?.url || '';
    const mobileUrl = subscriptionBlockData?.mobile_image?.url || '';
    const bannerHeader = subscriptionBlockData?.banner_content?.header || '';
    const bannerSubHeader = subscriptionBlockData?.banner_content?.sub_header || '';
    const position = subscriptionBlockData?.banner_content?.copy_alignment || '';

    // for Banner Button
    const ctaButton = subscriptionBlockData?.banner_content?.cta_button?.title || '';
    const ctaButtonURL = subscriptionBlockData?.banner_content?.cta_button?.href || '';
    // for styling bannerHeadline
    const headerbannerStyle = {
        color: subscriptionBlockData?.banner_content?.headline_font_color || '#000000',
    };
    // for styling bannerSubHeadline
    const headerSubHeaderStyle = {
        color: subscriptionBlockData?.banner_content?.sub_headline_font_color || '#000000',
    };

    const flexJustifyDirection = (direction) => {
        switch (direction) {
            case 'left':
                return 'flex-start';

            case 'center':
                return 'center';

            case 'right':
                return 'flex-end';

            default:
                return 'center';
        }
    };

    const desktopSubscription = () => (
        <div style={{
            width: '1400px', height: '500px', margin: '0 auto', backgroundImage: `url('${url}')`, backgroundRepeat: 'no-repeat', backgroundPosition: '50% 50%', position: 'relative',
        }}
        >
            <div className={classes.contextBoxPosition} style={{ justifyContent: flexJustifyDirection(position) }}>
                <div className={classes.contentBoxContainer}>
                    <div className={classes.contentInnerBoxContainer}>
                        <div style={headerbannerStyle}>
                            <ReactMarkdown className={classes.bannerText} source={bannerHeader} />
                        </div>
                        <div style={headerSubHeaderStyle}>
                            <ReactMarkdown className={classes.bannerSubText} source={bannerSubHeader} />
                        </div>
                        {ctaButtonURL && (
                            <div className={classes.ctaBtnContainer}>
                                <Link
                                    className={classes.ctaBtn}
                                    to={ctaButtonURL}
                                    onClick={() => trackEvent({
                                        eventCategory: 'Subscriptions',
                                        eventAction: 'Banner',
                                        eventLabel: ctaButton,
                                    })}
                                >
                                    {ctaButton}
                                </Link>
                            </div>
                        )}
                        <div className={classes.tilesterms}>
                            {subscriptionBlockData?.banner_content?.terms?.href.includes('#')
                                ? (
                                    <button type="button" onClick={scrollToDisclaimer}>
                                        {subscriptionBlockData?.banner_content?.terms?.title}
                                    </button>
                                ) : (
                                    <Link to={subscriptionBlockData?.banner_content?.terms?.href}>
                                        {subscriptionBlockData?.banner_content?.terms?.title}
                                    </Link>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const mobileSubscriptionBlock = () => (
        <div style={{
            width: '100%', backgroundSize: 'cover', margin: '0 auto', backgroundImage: `url('${mobileUrl}')`, backgroundPosition: '50% 50%',  backgroundRepeat: 'no-repeat', position: 'relative',
        }}
        >
            <div className={classes.contextBoxPosition}>
                <div className={classes.contentBoxContainer}>
                    <div className={classes.contentInnerBoxContainer}>
                        <div style={headerbannerStyle}>
                            <ReactMarkdown className={classes.bannerText} source={bannerHeader} />
                        </div>
                        <div style={headerSubHeaderStyle}>
                            <ReactMarkdown className={classes.bannerSubText} source={bannerSubHeader} />
                        </div>
                        {ctaButtonURL && (
                            <div className={classes.ctaBtnContainer}>
                                <Link
                                    className={classes.ctaBtn}
                                    to={ctaButtonURL}
                                    onClick={() => trackEvent({
                                        eventCategory: 'Subscriptions',
                                        eventAction: 'Banner',
                                        eventLabel: ctaButton,
                                    })}
                                >
                                    {`${ctaButton} >`}
                                </Link>
                            </div>
                        )}
                        <div className={classes.tilesterms}>
                            {subscriptionBlockData?.banner_content?.terms?.href.includes('#')
                                ? (
                                    <button type="button" onClick={scrollToDisclaimer}>
                                        {subscriptionBlockData?.banner_content?.terms?.title}
                                    </button>
                                ) : (
                                    <Link to={subscriptionBlockData?.banner_content?.terms?.href}>
                                        {subscriptionBlockData?.banner_content?.terms?.title}
                                    </Link>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <DesktopMobile
                breakpoint={600}
                desktop={() => desktopSubscription()}
                mobile={() => mobileSubscriptionBlock()}
            />
        </>
    );
};

SubscriptionBlock.propTypes = {
    classes: object,
    item: shape({
        banner_content: shape({
            cta_button_background_color: string,
            cta_button_text_color: string,
            headline: string,
            headline_font_color: string,
            sub_headline: string,
            sub_headline_font_color: string,
        }),
        desktop_image: shape({
            title: string,
            url: string,
        }),
        link: shape({
            title: string,
            href: string,
        }),
    }),
    scrollToDisclaimer: func,
    trackEvent: func.isRequired,
};
SubscriptionBlock.defaultProps = {
    classes: {},
    item: {},
    scrollToDisclaimer: () => {},
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(trackEventActions, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
    withStyles(styles),
);

export default enhance(SubscriptionBlock);
